import React from "react";
import {
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
} from "@mui/material";
import EcnInput from "../StyledComponents/EcnInput";
import EcnCheckbox from "../StyledComponents/EcnCheckbox";
interface AppData {
  appData: any;
  setAppData: any;
  submitAttempted: any;
  color?: string;
  radius?: string;
}

const QuestionStep = ({ appData, setAppData, submitAttempted, color = "#0034BB",
  radius = "0px" }: AppData) => {
  // styles
  const handleInputChange = (index: number, value: any) => {
    const trimmedValue = value;

    const updatedQuestions = appData.job_questions.map(
      (question: any, i: number) =>
        i === index
          ? { ...question, values: trimmedValue ? [trimmedValue] : [] } // If value is empty, store an empty array
          : question
    );

    setAppData({ ...appData, job_questions: updatedQuestions });
  };
  const handleRecommendedInputChange = (index: number, value: any) => {
    const trimmedValue = value;

    const updatedQuestions = appData.job_recommended_questions.map(
      (question: any, i: number) =>
        i === index
          ? { ...question, values: trimmedValue ? [trimmedValue] : [] } // If value is empty, store an empty array
          : question
    );

    setAppData({ ...appData, job_recommended_questions: updatedQuestions });
  };
  const handleRecommendedCheckboxChange = (index: number, value: string) => {
    const updatedQuestions = appData.job_recommended_questions.map(
      (question: any, i: number) => {
        if (i === index) {
          const currentValues = question.values || [];
          const newValues = currentValues.includes(value)
            ? currentValues.filter((v: string) => v !== value)
            : [...currentValues.filter((v: any) => v !== ""), value];
          return { ...question, values: newValues };
        }
        return question;
      }
    );
    setAppData({ ...appData, job_recommended_questions: updatedQuestions });
  };

  const handleCheckboxChange = (index: number, value: string) => {
    const updatedQuestions = appData.job_questions.map(
      (question: any, i: number) => {
        if (i === index) {
          const currentValues = question.values || [];
          const newValues = currentValues.includes(value)
            ? currentValues.filter((v: string) => v !== value)
            : [...currentValues.filter((v: any) => v !== ""), value];
          return { ...question, values: newValues };
        }
        return question;
      }
    );
    setAppData({ ...appData, job_questions: updatedQuestions });
  };

  return (
    <div className="questions-step">
      {appData?.job_recommended_questions?.map(
        (question: any, index: number) => (
          <div className="question-wrapper" key={index}>
            <p className="que">
              {replaceBracketContent(question?.name, question?.label_value)}
              <span style={{ color: color }}>
                {question?.required ? "*" : ""}
              </span>
            </p>
            {question.type === 0 &&
              (question.key === "Scores" ? (
                <div className="score-options-wrapper">
                  {question.score_options?.map((option: any, idx: number) => (
                    <div key={idx} className="score-input-group">
                      <p className="que"
                        style={{ marginTop: "10px" }}
                      >
                        {option.key}
                        <span style={{ color: color }}>
                          {option?.required ? "*" : ""}
                        </span>
                      </p>
                      <EcnInput
                        className="ecn-input"
                        size="small"
                        fullWidth
                        required={option?.required}
                        value={option.values?.[0] || ""}
                        type="number"
                        inputProps={{
                          step: option.key === "CGPA" ? "0.01" : "1",
                          min: option.key === "CGPA" ? "0" : "0",
                          max:
                            option.key === "CGPA"
                              ? "10"
                              : option.key === "SAT"
                                ? "1600"
                                : option.key === "GMAT"
                                  ? "800"
                                  : option.key === "GRE"
                                    ? "340"
                                    : undefined
                        }}
                        onChange={(e) => {
                          let value = e.target.value;

                          if (value === "") {
                            const updatedScoreOptions = question.score_options.map(
                              (opt: any, i: number) =>
                                i === idx
                                  ? (() => {
                                    const { values, ...rest } = opt;
                                    return rest;
                                  })()
                                  : opt
                            );
                            const updatedQuestions = appData.job_recommended_questions.map(
                              (q: any, i: number) =>
                                i === index ? { ...q, score_options: updatedScoreOptions } : q
                            );
                            setAppData({
                              ...appData,
                              job_recommended_questions: updatedQuestions
                            });
                            return;
                          }

                          if (option.key === "CGPA") {
                            const num = parseFloat(value);
                            value = isNaN(num) ? "" : Math.min(10, Math.max(0, num)).toString();
                          } else if (option.key === "SAT") {
                            const num = parseInt(value);
                            value = isNaN(num) ? "" : Math.min(1600, Math.max(0, num)).toString();
                          } else if (option.key === "GMAT") {
                            const num = parseInt(value);
                            value = isNaN(num) ? "" : Math.min(800, Math.max(0, num)).toString();
                          } else if (option.key === "GRE") {
                            const num = parseInt(value);
                            value = isNaN(num) ? "" : Math.min(340, Math.max(0, num)).toString();
                          }

                          const updatedScoreOptions = question.score_options.map(
                            (opt: any, i: number) =>
                              i === idx ? { ...opt, values: [value] } : opt
                          );
                          const updatedQuestions = appData.job_recommended_questions.map(
                            (q: any, i: number) =>
                              i === index ? { ...q, score_options: updatedScoreOptions } : q
                          );
                          setAppData({
                            ...appData,
                            job_recommended_questions: updatedQuestions
                          });
                        }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <EcnInput
                  className="ecn-input"
                  size="small"
                  fullWidth
                  required={question?.required}
                  value={question?.values[0] || ""}
                  onChange={(e) =>
                    handleRecommendedInputChange(index, e.target.value)
                  }
                />
              ))}
            {question.type === 2 && (
              <RadioGroup
                value={question?.values?.[0] || ""}
                onChange={(e) =>
                  handleRecommendedInputChange(index, e.target.value)
                }
              >
                {question?.options?.map((option: string) => (
                  <FormControlLabel
                    className="choice-label"
                    key={option}
                    value={option}
                    control={
                      <Radio
                        sx={{
                          color: color,
                          '&.Mui-checked': { color: color },
                        }}
                      />
                    }
                    label={option}
                  />
                ))}
              </RadioGroup>
            )}
            {question.type === 5 && (
              <FormGroup>
                {question?.options?.map((option: string) => (
                  <FormControlLabel
                    key={option}
                    className="choice-label"
                    control={
                      <Checkbox
                        sx={{
                          color: color,
                          '&.Mui-checked': { color: color },
                        }}
                        checked={question?.values?.includes(option) || false}
                        onChange={() =>
                          handleRecommendedCheckboxChange(index, option)
                        }
                      />
                    }
                    label={option}
                  />
                ))}
              </FormGroup>
            )}
            {question.type === 11 && (
            <FormGroup>
              <TextField
                required={question?.required}
                multiline
                minRows={4}
                maxRows={4}
                fullWidth
                variant="outlined"
                value={question?.values[0] || ""}
                onChange={(e) =>  handleRecommendedInputChange(index, e.target.value)}
              />
            </FormGroup>
          )}
            {submitAttempted &&
              (question?.key === "Scores"
                ? question?.score_options?.some(
                  (opt: any) => opt.required && (!opt.values || opt.values.length === 0)
                )
                : question?.values?.length === 0 || question?.values?.[0] === "") ? (
              <p className="custom-error-text">This Question is required</p>
            ) : null}
          </div>
        )
      )}
      {appData?.job_questions?.map((question: any, index: number) => (
        <div className="question-wrapper" key={index}>
          <p className="que">
            {question?.name}
            <span style={{ color: color }}>
              {question?.required ? "*" : ""}
            </span>
          </p>
          {question.type === 0 && (
            <EcnInput
              className="ecn-input"
              size="small"
              fullWidth
              required={question?.required}
              value={question?.values[0] || ""}
              onChange={(e) => handleInputChange(index, e.target.value)}
            />
          )}
          {question.type === 2 && (
            <RadioGroup
              value={question?.values?.[0] || ""}
              onChange={(e) => handleInputChange(index, e.target.value)}
            >
              {question?.options?.map((option: string) => (
                <FormControlLabel
                  className="choice-label"
                  key={option}
                  value={option}
                  control={
                    <Radio
                      sx={{
                        color: color,
                        '&.Mui-checked': { color: color },
                      }}
                    />
                  }
                  label={option}
                />
              ))}
            </RadioGroup>
          )}
          {question.type === 5 && (
            <FormGroup>
              {question?.options?.map((option: string) => (
                <FormControlLabel
                  key={option}
                  className="choice-label"
                  control={
                    <EcnCheckbox
                      sx={{
                        color: color,
                        '&.Mui-checked': { color: color },
                      }}
                      checked={question?.values?.includes(option) || false}
                      onChange={() => handleCheckboxChange(index, option)}
                    />
                  }
                  label={option}
                />
              ))}
            </FormGroup>
          )}
          {question.type === 11 && (
            <FormGroup>
              <TextField
                required={question?.required}
                multiline
                minRows={4}
                maxRows={4}
                fullWidth
                variant="outlined"
                value={question?.values[0] || ""}
                onChange={(e) => handleInputChange(index, e.target.value)}
              />
            </FormGroup>
          )}
          {submitAttempted &&
            (question?.values?.length === 0 || question?.values?.[0] === "") ? (
            <p className="custom-error-text">This Question is required</p>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default QuestionStep;

function replaceBracketContent(str: any, replacement: any) {
  return str.replace(/\[.*?\]/g, replacement);
}

